import styled from 'styled-components';
import { IC_DOCTOR_BG, IC_EPHARMACY_BG, IC_HOMECARE_BG } from '../../Assets/images';

export const ModuleButtonStyled = styled.div`
   margin-top: 16px;
  .redirectionHotLinks {
    width: 100%;

    .container {
      display: flex;
      justify-content: center;
      margin-bottom: 8px;
      margin-top: 8px;
      gap: 16px;

      .btn {
        justify-content: flex-start;
        height: 80px;
        margin: 0 !important;
      }

      .btnDoctor {
        .btn {
          border-color: ${(props) => props?.theme?.blue?.light};
          background-image: url(${IC_DOCTOR_BG.src}),
            linear-gradient(57.07deg, ${(props) => props?.theme?.blue?.light} 36.1%, #18c8ff 100%);
          transition: opacity 0.4s ease;
          background-position: center right;
          background-repeat: no-repeat;
          border: 0;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .btnEPharmacy {
        .btn {
          border-color: ${(props) => props?.theme?.green?.light};
          border: 0;
          transition: opacity 0.4s ease;
          background-position: center right;
          background-repeat: no-repeat;
          background-image: url(${IC_EPHARMACY_BG.src}),
            linear-gradient(57.07deg, ${(props) => props?.theme?.green?.light} 36.1%, #c4e171 100%);
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .btnHomecare {
        .btn {
          border-color: ${(props) => props?.theme?.text?.lightBlue};
          background-image: url(${IC_HOMECARE_BG.src}), linear-gradient(57.07deg, #2c3e70 36.1%, #708ee1 100%);
          transition: opacity 0.4s ease;
          background-position: 105% -105%;
          background-repeat: no-repeat;
          border: 0;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }

  @media (max-width: 820px) {
    .redirectionHotLinks {
      a{
        color: inherit;
        text-decoration: none;
      }
      .container {
        gap: 14px;
        .btnDoctor,
        .btnEPharmacy,
        .btnHomecare {
          width: 100%;
          .btn {
            min-width: 1px !important;
            width: 100%;
          }
        }
        .btnDoctor {
          .btn {
            margin-left: 0;
          }
        }
        .btnEPharmacy {
          .btn {
            margin-right: 0;
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .redirectionHotLinks {
      .container {
        gap: 14px;
        .btnDoctor,
        .btnEPharmacy,
        .btnHomecare {
          .btn {
            min-width: 1px !important;
            width: 100%;
            min-width: 1px !important;
            max-width: 118px;
            margin-left: 0;
            margin-right: 0;
            display: flex;
            flex-direction: column !important;
            text-align: start;
            align-items: flex-start !important;
            height: 114px;
            padding-left: 10px !important;
          }
        }

        .btnDoctor {
          .btn {
            background-image: linear-gradient(
              57.07deg,
              ${(props) => props?.theme?.blue?.light} 36.1%,
              #18c8ff 100%
            ) !important;
          }
        }
        .btnEPharmacy {
          .btn {
            background-image: linear-gradient(
              57.07deg,
              ${(props) => props?.theme?.green?.light} 36.1%,
              #c4e171 100%
            ) !important;
          }
        }
        .btnHomecare {
          .btn {
            background-image: linear-gradient(57.07deg, #2c3e70 36.1%, #708ee1 100%) !important;
          }
        }

        .btn {
          .left {
            margin-right: 0;
          }
        }
      }
    }
  }
`;
